import type { NamespaceCatalog } from '@/i18n/ns';

export type ActionPrimaryKey =
  | 'saveDraft'
  | 'createAndEnable'
  | 'createAgent'
  | 'applyAgentChanges'
  | 'enableSchedule'
  | 'saveTrigger'
  | 'runAgent'
  | 'applyProjectChanges'
  | 'removeConnection'
  | 'useMyAccess'
  | 'connect';

const catalog = {
  en: {
    saveDraft: 'Save draft',
    createAndEnable: 'Create & enable schedule',
    createAgent: 'Create agent',
    applyAgentChanges: 'Apply agent changes',
    enableSchedule: 'Enable schedule',
    saveTrigger: 'Save trigger',
    runAgent: 'Run agent',
    applyProjectChanges: 'Apply project changes',
    removeConnection: 'Remove connection',
    useMyAccess: 'Use my access',
    connect: 'Connect',
  },
  bg: {
    saveDraft: 'Запази черновата',
    createAndEnable: 'Създай и активирай графика',
    createAgent: 'Създай агент',
    applyAgentChanges: 'Приложи промените по агента',
    enableSchedule: 'Активирай графика',
    saveTrigger: 'Запази задействането',
    runAgent: 'Стартирай агента',
    applyProjectChanges: 'Приложи промените по проекта',
    removeConnection: 'Премахни връзката',
    useMyAccess: 'Използвай моя достъп',
    connect: 'Свържи',
  },
  hr: {
    saveDraft: 'Spremi skicu',
    createAndEnable: 'Izradi i omogući raspored',
    createAgent: 'Izradi agenta',
    applyAgentChanges: 'Primijeni promjene agenta',
    enableSchedule: 'Omogući raspored',
    saveTrigger: 'Spremi okidač',
    runAgent: 'Pokreni agenta',
    applyProjectChanges: 'Primijeni promjene projekta',
    removeConnection: 'Ukloni vezu',
    useMyAccess: 'Upotrijebi moj pristup',
    connect: 'Poveži',
  },
  cs: {
    saveDraft: 'Uložit koncept',
    createAndEnable: 'Vytvořit a aktivovat plán',
    createAgent: 'Vytvořit agenta',
    applyAgentChanges: 'Použít změny agenta',
    enableSchedule: 'Aktivovat plán',
    saveTrigger: 'Uložit spouštěč',
    runAgent: 'Spustit agenta',
    applyProjectChanges: 'Použít změny projektu',
    removeConnection: 'Odebrat připojení',
    useMyAccess: 'Použít můj přístup',
    connect: 'Připojit',
  },
  da: {
    saveDraft: 'Gem kladde',
    createAndEnable: 'Opret og aktivér tidsplan',
    createAgent: 'Opret agent',
    applyAgentChanges: 'Anvend agentændringer',
    enableSchedule: 'Aktivér tidsplan',
    saveTrigger: 'Gem udløser',
    runAgent: 'Kør agent',
    applyProjectChanges: 'Anvend projektændringer',
    removeConnection: 'Fjern forbindelse',
    useMyAccess: 'Brug min adgang',
    connect: 'Forbind',
  },
  nl: {
    saveDraft: 'Concept opslaan',
    createAndEnable: 'Planning maken en inschakelen',
    createAgent: 'Agent maken',
    applyAgentChanges: 'Agentwijzigingen toepassen',
    enableSchedule: 'Planning inschakelen',
    saveTrigger: 'Trigger opslaan',
    runAgent: 'Agent uitvoeren',
    applyProjectChanges: 'Projectwijzigingen toepassen',
    removeConnection: 'Verbinding verwijderen',
    useMyAccess: 'Mijn toegang gebruiken',
    connect: 'Verbinden',
  },
  et: {
    saveDraft: 'Salvesta mustand',
    createAndEnable: 'Loo ja luba ajakava',
    createAgent: 'Loo agent',
    applyAgentChanges: 'Rakenda agendi muudatused',
    enableSchedule: 'Luba ajakava',
    saveTrigger: 'Salvesta käivitaja',
    runAgent: 'Käivita agent',
    applyProjectChanges: 'Rakenda projekti muudatused',
    removeConnection: 'Eemalda ühendus',
    useMyAccess: 'Kasuta minu juurdepääsu',
    connect: 'Ühenda',
  },
  fi: {
    saveDraft: 'Tallenna luonnos',
    createAndEnable: 'Luo ajoitus ja ota se käyttöön',
    createAgent: 'Luo agentti',
    applyAgentChanges: 'Ota agentin muutokset käyttöön',
    enableSchedule: 'Ota ajoitus käyttöön',
    saveTrigger: 'Tallenna käynnistin',
    runAgent: 'Suorita agentti',
    applyProjectChanges: 'Ota projektin muutokset käyttöön',
    removeConnection: 'Poista yhteys',
    useMyAccess: 'Käytä käyttöoikeuksiani',
    connect: 'Yhdistä',
  },
  fr: {
    saveDraft: 'Enregistrer le brouillon',
    createAndEnable: 'Créer et activer la planification',
    createAgent: 'Créer un agent',
    applyAgentChanges: 'Appliquer les modifications de l’agent',
    enableSchedule: 'Activer la planification',
    saveTrigger: 'Enregistrer le déclencheur',
    runAgent: 'Exécuter l’agent',
    applyProjectChanges: 'Appliquer les modifications du projet',
    removeConnection: 'Supprimer la connexion',
    useMyAccess: 'Utiliser mon accès',
    connect: 'Connecter',
  },
  de: {
    saveDraft: 'Entwurf speichern',
    createAndEnable: 'Zeitplan erstellen und aktivieren',
    createAgent: 'Agent erstellen',
    applyAgentChanges: 'Agentenänderungen übernehmen',
    enableSchedule: 'Zeitplan aktivieren',
    saveTrigger: 'Trigger speichern',
    runAgent: 'Agent ausführen',
    applyProjectChanges: 'Projektänderungen übernehmen',
    removeConnection: 'Verbindung entfernen',
    useMyAccess: 'Meinen Zugriff verwenden',
    connect: 'Verbinden',
  },
  el: {
    saveDraft: 'Αποθήκευση πρόχειρου',
    createAndEnable: 'Δημιουργία και ενεργοποίηση χρονοδιαγράμματος',
    createAgent: 'Δημιουργία πράκτορα',
    applyAgentChanges: 'Εφαρμογή αλλαγών πράκτορα',
    enableSchedule: 'Ενεργοποίηση χρονοδιαγράμματος',
    saveTrigger: 'Αποθήκευση ενεργοποιητή',
    runAgent: 'Εκτέλεση πράκτορα',
    applyProjectChanges: 'Εφαρμογή αλλαγών έργου',
    removeConnection: 'Κατάργηση σύνδεσης',
    useMyAccess: 'Χρήση της πρόσβασής μου',
    connect: 'Σύνδεση',
  },
  hu: {
    saveDraft: 'Piszkozat mentése',
    createAndEnable: 'Ütemezés létrehozása és engedélyezése',
    createAgent: 'Ügynök létrehozása',
    applyAgentChanges: 'Ügynökmódosítások alkalmazása',
    enableSchedule: 'Ütemezés engedélyezése',
    saveTrigger: 'Eseményindító mentése',
    runAgent: 'Ügynök futtatása',
    applyProjectChanges: 'Projektmódosítások alkalmazása',
    removeConnection: 'Kapcsolat eltávolítása',
    useMyAccess: 'Saját hozzáférésem használata',
    connect: 'Csatlakozás',
  },
  ga: {
    saveDraft: 'Sábháil dréacht',
    createAndEnable: 'Cruthaigh agus cumasaigh sceideal',
    createAgent: 'Cruthaigh gníomhaire',
    applyAgentChanges: 'Cuir athruithe an ghníomhaire i bhfeidhm',
    enableSchedule: 'Cumasaigh sceideal',
    saveTrigger: 'Sábháil truicear',
    runAgent: 'Rith gníomhaire',
    applyProjectChanges: 'Cuir athruithe an tionscadail i bhfeidhm',
    removeConnection: 'Bain nasc',
    useMyAccess: 'Úsáid mo rochtain',
    connect: 'Ceangail',
  },
  it: {
    saveDraft: 'Salva bozza',
    createAndEnable: 'Crea e abilita programmazione',
    createAgent: 'Crea agente',
    applyAgentChanges: "Applica modifiche all'agente",
    enableSchedule: 'Abilita programmazione',
    saveTrigger: 'Salva trigger',
    runAgent: 'Esegui agente',
    applyProjectChanges: 'Applica modifiche al progetto',
    removeConnection: 'Rimuovi connessione',
    useMyAccess: 'Usa il mio accesso',
    connect: 'Connetti',
  },
  lv: {
    saveDraft: 'Saglabāt melnrakstu',
    createAndEnable: 'Izveidot un iespējot grafiku',
    createAgent: 'Izveidot aģentu',
    applyAgentChanges: 'Lietot aģenta izmaiņas',
    enableSchedule: 'Iespējot grafiku',
    saveTrigger: 'Saglabāt aktivizētāju',
    runAgent: 'Palaist aģentu',
    applyProjectChanges: 'Lietot projekta izmaiņas',
    removeConnection: 'Noņemt savienojumu',
    useMyAccess: 'Izmantot manu piekļuvi',
    connect: 'Savienot',
  },
  lt: {
    saveDraft: 'Išsaugoti juodraštį',
    createAndEnable: 'Sukurti ir įjungti tvarkaraštį',
    createAgent: 'Sukurti agentą',
    applyAgentChanges: 'Taikyti agento pakeitimus',
    enableSchedule: 'Įjungti tvarkaraštį',
    saveTrigger: 'Išsaugoti paleidiklį',
    runAgent: 'Paleisti agentą',
    applyProjectChanges: 'Taikyti projekto pakeitimus',
    removeConnection: 'Pašalinti ryšį',
    useMyAccess: 'Naudoti mano prieigą',
    connect: 'Prisijungti',
  },
  mt: {
    saveDraft: 'Issejvja l-abbozz',
    createAndEnable: 'Oħloq u attiva l-iskeda',
    createAgent: 'Oħloq aġent',
    applyAgentChanges: 'Applika l-bidliet tal-aġent',
    enableSchedule: 'Attiva l-iskeda',
    saveTrigger: 'Issejvja l-attivatur',
    runAgent: 'Ħaddem l-aġent',
    applyProjectChanges: 'Applika l-bidliet tal-proġett',
    removeConnection: 'Neħħi l-konnessjoni',
    useMyAccess: 'Uża l-aċċess tiegħi',
    connect: 'Qabbad',
  },
  pl: {
    saveDraft: 'Zapisz wersję roboczą',
    createAndEnable: 'Utwórz i włącz harmonogram',
    createAgent: 'Utwórz agenta',
    applyAgentChanges: 'Zastosuj zmiany agenta',
    enableSchedule: 'Włącz harmonogram',
    saveTrigger: 'Zapisz wyzwalacz',
    runAgent: 'Uruchom agenta',
    applyProjectChanges: 'Zastosuj zmiany w projekcie',
    removeConnection: 'Usuń połączenie',
    useMyAccess: 'Użyj mojego dostępu',
    connect: 'Połącz',
  },
  pt: {
    saveDraft: 'Salvar rascunho',
    createAndEnable: 'Criar e ativar agendamento',
    createAgent: 'Criar agente',
    applyAgentChanges: 'Aplicar alterações do agente',
    enableSchedule: 'Ativar agendamento',
    saveTrigger: 'Salvar gatilho',
    runAgent: 'Executar agente',
    applyProjectChanges: 'Aplicar alterações do projeto',
    removeConnection: 'Remover conexão',
    useMyAccess: 'Usar meu acesso',
    connect: 'Conectar',
  },
  ro: {
    saveDraft: 'Salvează schița',
    createAndEnable: 'Creează și activează programarea',
    createAgent: 'Creează agentul',
    applyAgentChanges: 'Aplică modificările agentului',
    enableSchedule: 'Activează programarea',
    saveTrigger: 'Salvează declanșatorul',
    runAgent: 'Rulează agentul',
    applyProjectChanges: 'Aplică modificările proiectului',
    removeConnection: 'Elimină conexiunea',
    useMyAccess: 'Folosește accesul meu',
    connect: 'Conectează-te',
  },
  sk: {
    saveDraft: 'Uložiť koncept',
    createAndEnable: 'Vytvoriť a povoliť plán',
    createAgent: 'Vytvoriť agenta',
    applyAgentChanges: 'Použiť zmeny agenta',
    enableSchedule: 'Povoliť plán',
    saveTrigger: 'Uložiť spúšťač',
    runAgent: 'Spustiť agenta',
    applyProjectChanges: 'Použiť zmeny projektu',
    removeConnection: 'Odstrániť pripojenie',
    useMyAccess: 'Použiť môj prístup',
    connect: 'Pripojiť',
  },
  sl: {
    saveDraft: 'Shrani osnutek',
    createAndEnable: 'Ustvari in omogoči urnik',
    createAgent: 'Ustvari agenta',
    applyAgentChanges: 'Uveljavi spremembe agenta',
    enableSchedule: 'Omogoči urnik',
    saveTrigger: 'Shrani sprožilec',
    runAgent: 'Zaženi agenta',
    applyProjectChanges: 'Uveljavi spremembe projekta',
    removeConnection: 'Odstrani povezavo',
    useMyAccess: 'Uporabi moj dostop',
    connect: 'Poveži',
  },
  es: {
    saveDraft: 'Guardar borrador',
    createAndEnable: 'Crear y activar programación',
    createAgent: 'Crear agente',
    applyAgentChanges: 'Aplicar cambios del agente',
    enableSchedule: 'Activar programación',
    saveTrigger: 'Guardar disparador',
    runAgent: 'Ejecutar agente',
    applyProjectChanges: 'Aplicar cambios del proyecto',
    removeConnection: 'Eliminar conexión',
    useMyAccess: 'Usar mi acceso',
    connect: 'Conectar',
  },
  sv: {
    saveDraft: 'Spara utkast',
    createAndEnable: 'Skapa och aktivera schema',
    createAgent: 'Skapa agent',
    applyAgentChanges: 'Tillämpa agentändringar',
    enableSchedule: 'Aktivera schema',
    saveTrigger: 'Spara utlösare',
    runAgent: 'Kör agent',
    applyProjectChanges: 'Tillämpa projektändringar',
    removeConnection: 'Ta bort anslutning',
    useMyAccess: 'Använd min åtkomst',
    connect: 'Anslut',
  },
} as const satisfies NamespaceCatalog<ActionPrimaryKey>;

export default catalog;
